export enum AllocationViewDayOfWeekEnum {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export const AllocationViewDayOfWeek = [
  AllocationViewDayOfWeekEnum.Sunday,
  AllocationViewDayOfWeekEnum.Monday,
  AllocationViewDayOfWeekEnum.Tuesday,
  AllocationViewDayOfWeekEnum.Wednesday,
  AllocationViewDayOfWeekEnum.Thursday,
  AllocationViewDayOfWeekEnum.Friday,
  AllocationViewDayOfWeekEnum.Saturday,
];
